import * as React from 'react';

function SvgSearchTableFilter(props) {
  return (
    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.357a4.357 4.357 0 117.987 2.411L9.749 8.53c.334.336.334.88.002 1.216l-.005.005a.862.862 0 01-1.216-.003L6.768 7.987A4.357 4.357 0 010 4.357zm9.237 4.684zm-4.88-7.318a2.63 2.63 0 00-1.862.772 2.627 2.627 0 00-.566 2.886c.133.313.323.596.566.838a2.627 2.627 0 002.886.566h.001c.313-.133.594-.322.837-.566a2.627 2.627 0 00.566-2.886 2.63 2.63 0 00-.566-.838 2.627 2.627 0 00-1.862-.772z"
        fill="#979797"
      />
    </svg>
  );
}

export default SvgSearchTableFilter;
